import styled, { css } from 'styled-components';

import BootstrapModal from 'react-bootstrap/Modal';

export const StyledModal = styled(BootstrapModal)`
  z-index: 9999 !important;
  width: 500px;
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -10%);
  margin: 0 auto;
`;

export const StyledModalBody = styled(BootstrapModal.Body)``;
